import { render, staticRenderFns } from "./editPhone.vue?vue&type=template&id=efa3289a&scoped=true"
import script from "./editPhone.vue?vue&type=script&lang=js"
export * from "./editPhone.vue?vue&type=script&lang=js"
import style0 from "./editPhone.vue?vue&type=style&index=0&id=efa3289a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa3289a",
  null
  
)

export default component.exports